import styled from 'styled-components';

export const OuterContainer = styled.div`
  position: fixed; /* Stay in place */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1; /* Sit on top */
  padding-bottom: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.5);
  font-family: "Figtree", ui-sans-serif, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
`;

export const ModalContainer = styled.div`
  background-color: #fefefe;
  border: 1px solid #888;
  border-radius: 5px;
  padding: 1.5rem;
  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    > * {
      color: black;
      font-weight: bold;
    }
    .headerContent {
      display: flex;
    }
  }
  main {
    margin-top: 1.5rem;
  }
  footer {
    margin-top: 1.5rem;
    display: flex;
    padding: 1em 0.5em 0.5em 0.5em;
    justify-content: flex-end;
    > *:not(:last-child) {
      margin-right: 0.5em;
    }
  }
`;
